import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type UpdateShareSingleAssetBehaviorMutationVariables = Types.Exact<{
  shareId: Types.Scalars['ID']['input'];
  openSingleAssetInViewer?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type UpdateShareSingleAssetBehaviorMutation = { __typename?: 'Mutation', updateShare?: { __typename?: 'UpdateSharePayload', share?: { __typename?: 'AdHocAssetsShare', id: string, openSingleAssetInViewer: boolean } | { __typename?: 'CollectionShare', id: string, openSingleAssetInViewer: boolean } | null } | null };


export const UpdateShareSingleAssetBehavior = /*#__PURE__*/ gql`
    mutation UpdateShareSingleAssetBehavior($shareId: ID!, $openSingleAssetInViewer: Boolean) {
  updateShare(
    input: {shareId: $shareId, settings: {openSingleAssetInViewer: $openSingleAssetInViewer}}
  ) {
    share {
      id
      openSingleAssetInViewer
    }
  }
}
    ` as unknown as DocumentNode<UpdateShareSingleAssetBehaviorMutation, UpdateShareSingleAssetBehaviorMutationVariables>;

          

          export const useUpdateShareSingleAssetBehaviorMutation = (options?:MutationHookOptions<UpdateShareSingleAssetBehaviorMutation, UpdateShareSingleAssetBehaviorMutationVariables>) => useMutation(UpdateShareSingleAssetBehavior, options);
          

          export type UpdateShareSingleAssetBehaviorMutationOptions = MutationHookOptions<UpdateShareSingleAssetBehaviorMutation, UpdateShareSingleAssetBehaviorMutationVariables>;

          

          export type UpdateShareSingleAssetBehaviorMutationResult = ReturnType<typeof useUpdateShareSingleAssetBehaviorMutation>[1];

          
